import React from 'react';
import PropTypes from 'prop-types';
import { Scatter } from 'react-chartjs-2';
import { getLoggedTimeFromHours } from '../../helpers/workLog';
import Strings from '../../common/Strings';

export const HourScatterChart = ({
  data,
  labels,
  chartXMax,
  chartYMax,
  stats,
  statsColor,
}) => {
  const options = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 32,
        right: 0,
        top: 32,
        bottom: 0,
      },
    },
    elements: {
      line: {
        tension: 0, // disables bezier curves
      },
    },
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltips: {
      titleFontFamily: 'Arial',
      titleFontSize: 11,
      titleFontStyle: 'normal',
      titleMarginBottom: 8,
      bodyFontFamily: 'Arial',
      bodyFontSize: 11,
      bodyFontStyle: 'bold',
      displayColors: false,
      callbacks: {
        title: tooltipItem => {
          return labels[tooltipItem[0].xLabel - 1];
        },
        label: tooltipItem => getLoggedTimeFromHours(tooltipItem.yLabel),
      },
    },
    scales: {
      xAxes: [
        {
          drawOnChartArea: true,
          ticks: {
            max: chartXMax - 1,
            display: false,
            stepSize: 1,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          drawOnChartArea: true,
          position: 'right',
          ticks: {
            suggestedMax: chartYMax,
            beginAtZero: true,
            display: true,
            fontFamily: 'Arial',
            fontSize: 10,
            fontColor: '#CBCBCB',
            callback: value => {
              if (value === 0) return '';
              if (value === 1) return value + Strings.COMMON.hourShort;
              return value + Strings.COMMON.hoursShort;
            },
          },
          gridLines: {
            display: true,
          },
        },
      ],
    },
  };

  if (stats.length !== 3) {
    alert('Stats must contain 3 values');
    return null;
  }

  const getStatsValue = stats => {
    if (stats.value) {
      return stats.value;
    } else if (stats.totalCost >= 0 && stats.currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: stats.currency,
      }).format(stats.totalCost);
    }
    return '0';
  };

  return (
    <div className="scatter-graph-container">
      <div className="scatter-graph">
        <Scatter data={data} options={options} />
      </div>
      <div className="scatter-graph-stats-root-container">
        <div className="scatter-graph-stats-container">
          <p className="scatter-graph-stats-title">{stats[0].label}</p>
          <p
            className="scatter-graph-stats-value"
            style={{ color: statsColor }}
          >
            {getStatsValue(stats[0])}
          </p>
        </div>
        <div className="scatter-graph-stats-divider" />
        <div className="scatter-graph-stats-container" style={{ flexGrow: 1 }}>
          <p className="scatter-graph-stats-title">{stats[1].label}</p>
          <p
            className="scatter-graph-stats-value"
            style={{ color: statsColor }}
          >
            {getStatsValue(stats[1])}
          </p>
        </div>
        <div className="scatter-graph-stats-divider" />
        <div
          className="scatter-graph-stats-container"
          style={{ marginRight: '5rem' }}
        >
          <p className="scatter-graph-stats-title">{stats[2].label}</p>
          <p
            className="scatter-graph-stats-value"
            style={{ color: statsColor }}
          >
            {getStatsValue(stats[2])}
          </p>
        </div>
      </div>
    </div>
  );
};

HourScatterChart.propTypes = {
  data: PropTypes.object.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  chartXMax: PropTypes.number.isRequired,
  chartYMax: PropTypes.number.isRequired,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
      totalCost: PropTypes.number,
      currency: PropTypes.string,
    }).isRequired,
  ).isRequired,
  statsColor: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/common/HourScatterChart.js